import { RawEventsConfigurationGridController } from '../controller/RawEventsConfigurationGridController';
import { BaseWebComponentElement } from '../../framework/BaseWebComponentElement';

export class RawEventsConfigurationGridWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: RawEventsConfigurationGridController,
    });
  }
}
